import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { buildRoomEntityV2 } from "@youm-front/room/util/factory";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomsListActions } from "../actions";
import {
  RoomCreateRequestDTO,
  RoomDeleteRequestDTO,
  RoomsListRequestDTO,
  RoomUpdateRequestDTO
} from "../dto";
import { RoomsListService } from "../services";

@Injectable()
export class RoomsListEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomsListService: RoomsListService
  ) {}

  roomCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomsListActions.roomCreate),
      switchMap(({ roomCreateCmd }) =>
        this.roomsListService
          .roomCreate(
            new RoomCreateRequestDTO({
              title: roomCreateCmd.value.title,
              description: roomCreateCmd.value.description,
              startAt: roomCreateCmd.value.startAt
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomsListActions.roomCreateSuccess({
                room: buildRoomEntityV2(_.data.room)
              })
            ]),
            catchError((_) => [
              RoomsListActions.roomCreateFailure({
                message: _.message
              })
            ])
          )
      )
    )
  );

  roomDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomsListActions.roomDelete),
      switchMap(({ roomDeleteCmd }) =>
        this.roomsListService
          .roomDelete(
            new RoomDeleteRequestDTO({
              roomId: roomDeleteCmd.value.roomId
            })
          )
          .pipe(
            mergeMap(() => [
              RoomsListActions.roomDeleteSuccess({
                roomDeleteCmd
              })
            ]),
            catchError((_) => [
              RoomsListActions.roomDeleteFailure({
                message: _.message
              })
            ])
          )
      )
    )
  );

  roomUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomsListActions.roomUpdate),
      switchMap(({ roomUpdateCmd }) =>
        this.roomsListService
          .roomUpdate(
            new RoomUpdateRequestDTO({
              roomId: roomUpdateCmd.value.roomId,
              roomTitle: roomUpdateCmd.value.roomTitle,
              roomDescription: roomUpdateCmd.value.roomDescription,
              roomStartAt: roomUpdateCmd.value.roomStartAt
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomsListActions.roomUpdateSuccess({
                room: buildRoomEntityV2(_.data.room)
              })
            ]),
            catchError((_) => [
              RoomsListActions.roomUpdateFailure({
                message: _.message
              })
            ])
          )
      )
    )
  );

  roomsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomsListActions.roomsList),
      switchMap(() =>
        this.roomsListService.roomsList(new RoomsListRequestDTO({})).pipe(
          mergeMap((_) => [
            RoomsListActions.roomsListSuccess({
              rooms: _.data.rooms.map((_) => buildRoomEntityV2(_))
            })
          ]),
          catchError((_) => [
            RoomsListActions.roomsListFailure({ message: _.message })
          ])
        )
      )
    )
  );
}
